/**
 * §1 Conformità, la curva del costo di conformità, in unità relative.
 *
 * `1` = tetto del grafico, `0` = linea dello zero: chi disegna decide la propria
 * mappatura in px. Sta qui perché la stessa curva vive in due posti, la scena
 * scrubbata `StandardsCostCurve` e la miniatura in loop dietro alla tile "SBTi"
 * del bento, e le due devono raccontare lo stesso andamento.
 */

/** quanti campioni ha la curva */
export const N = 13;

/** il prezzo della GO conforme sul mercato: sale fascia dopo fascia */
export const MARKET = [0.12, 0.14, 0.16, 0.19, 0.23, 0.29, 0.38, 0.48, 0.56, 0.63, 0.69, 0.74, 0.78];

/** sotto lo zero: parte in profondità e risale verso lo zero, gli impianti perdono
 *  efficienza negli anni, quindi il margine si assottiglia senza mai tornare un costo */
export const BELOW = [-0.45, -0.42, -0.39, -0.36, -0.34, -0.32, -0.3, -0.29, -0.28, -0.27, -0.25, -0.22, -0.2];

/**
 * La curva DEC alla posizione `k`:
 * `0` = sovrapposta al mercato, `1` = sulla linea dello zero, `2` = sotto.
 */
export const sampleCurve = (k: number) => MARKET.map((v, i) => (k <= 1 ? v * (1 - k) : BELOW[i] * (k - 1)));

/** Shared plot frame (viewBox coords) for the two conformità curves, the scrubbed
 *  `StandardsCostCurve` (solution page) and the static `ConformitaCurve` (dec-explorer). */
export const CURVE_FRAME = { VW: 480, VH: 250, X0: 64, X1: 462, TOP: 22, BOT: 236 } as const;

/** SBTi standard-band headers, the same three-band row both curves print above the plot. */
export const SBTI_BANDS = [
  { title: "SBTi v1", level: "LOW", tone: "text-dec-green" },
  { title: "SBTi v2", level: "MEDIUM", tone: "text-dec-orange" },
  { title: "SBTi v?", level: "HARD", tone: "text-red-600" },
] as const;
